export function copyTextToClipboard(text) {
  try {
    var clipboardData = event.clipboardData || window.clipboardData;
    clipboardData.setData("text", text);
    return text;
  } catch (err) {
    console.log("Unable to copy. " + err.toString());
  }
  return null;
}
